import { Link } from "react-router-dom";
import Explanation from "../../../layout/admin/Explanation";
import Button from "../../../ui/Button";
import styles from "../../../layout/admin/Main.module.scss";
import ScreenTitle from "../../../layout/admin/ScreenTitle";
import SubScreenTitle from "../../../layout/admin/SubScreenTitle";

const Completion = ({ subtitle, explanation, link, btntext }) => {
  return (
    <div className={styles.main}>
      <ScreenTitle>お知らせ管理</ScreenTitle>
      <SubScreenTitle>{subtitle}</SubScreenTitle>
      <Explanation>{explanation}</Explanation>
      <Link to={link}>
        <Button styleType="back">{btntext}</Button>
      </Link>
    </div>
  );
};

export default Completion;
